import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';
import Tooltip from '../../Tooltip';

const Container = styled.div`
  a {
    text-decoration: none;
  }

  .mailLinkContainer {
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    border-radius: 50%;
    background-color: rgba(173, 181, 189, 0.5);
    color: white;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mailLinkContainer:hover {
    cursor: pointer;
  }
`;

const EmptyValue = styled.div`
  height: 100%;
  opacity: 0.4;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    border-top: 2px solid ${(props) => props.theme.colors.dark};
    width: 12px;
  }
`;

const Cell = ({ value, ...otherProps }) => (
  <CellContainer {...otherProps}>
    {value ? (
      <Container>
        <Tooltip placement="top" content={value}>
          <div>
            {' '}
            <a target="_blank" href={`mailto:${value}`} rel="noreferrer">
              <div className="mailLinkContainer">
                <p>@</p>
              </div>
            </a>
          </div>
        </Tooltip>
      </Container>
    ) : (
      <EmptyValue>
        <div />
      </EmptyValue>
    )}
  </CellContainer>
);

export default Cell;
